<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap3">THREE</h1>
<p class="noind" style="margin-top:30px;">J<span class="small">ASON’S TROUBLES BEGAN WHEN</span> he was still a baby, on the day that his father, Diomedes II, suddenly stopped being king of Iolcus. The king was a gentle man, still young, and would have reigned many more years if it had not been for his stepbrother, Pelius the Impatient. He knocked Diomedes on the head and rolled him off a cliff into the sea, then named himself regent because the crown prince was an infant.</p>
<p class="ind">Pelius’s first royal act was to declare war on a neighboring country to give people something else to think about. Because he had plans for his nephew. He meant to solve the problem of succession very simply by dropping the baby out the window. But when he went to the nursery that night, he found the crib empty. He was frantic. He ordered the palace turned inside out. Every cottage, barn, and haystack for miles around was searched and searched again, but the infant prince had been swallowed by the night.</p>
<p class="ind">Thereupon Pelius announced that, in the light of the royal baby’s disappearance, it was the clear duty of the regent, who happened to be himself, to choose a new king, also himself. And now, as king, he could get on with the business of winning the war and celebrating that victory with another war, and on and on, until every patriotic Iolchian would thank the gods for allowing them to be ruled by a winner, even if he had been lethal about gaining the throne.</p>
<p class="ind">Pelius prospered. He grew in fame and wealth, getting meaner and fatter each year. But even as paunch and power grew, he kept being haunted by the idea that the little prince was alive somewhere and would turn up one day to claim his kingdom. He gave orders that every young stranger in the kingdom was to be watched very closely and killed on the spot if he came within ten miles of the castle.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 7chap3.vue?b9554778